// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { postRequestAlertVideo } from '../../services/AlertsService';
import { PostRequestVideo, AlertDetails } from '../../types/Alerts';

type Result = UseMutationResult<AlertDetails, Error, PostRequestVideo>;

function usePostRequestVideo(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(postRequestAlertVideo, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['alert-videos'] });
      queryClient.invalidateQueries({ queryKey: ['videos'] });
      queryClient.invalidateQueries({ queryKey: ['videos-lazy'] });
      queryClient.invalidateQueries({ queryKey: ['videos-lazy-latest'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePostRequestVideo;
